export default __webpack_public_path__ + "static/media/SFR_Logo_RVB.3ca6fe5c.png";